import { motion, useReducedMotion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const M = motion[as];
  return (
    <M
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
};

// Masked line-by-line reveal. The observer sits on the unclipped wrapper so it always fires.
export const MaskedLines = ({ lines, className = "", lineClass = "", delay = 0, stagger = 0.12, play = true, inView = false }) => {
  const reduce = useReducedMotion();
  const variants = {
    hidden: { y: "105%" },
    show: (i) => ({ y: "0%", transition: { duration: 1.05, delay: delay + i * stagger, ease } }),
  };
  const trigger = reduce
    ? {}
    : inView
      ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } }
      : { initial: "hidden", animate: play ? "show" : "hidden" };
  return (
    <motion.span className={`block ${className}`} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={reduce ? undefined : variants} custom={i}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] ${light ? "text-orange-700" : "text-orange-400"} ${className}`}>
    <span className="mr-3 inline-block h-px w-8 translate-y-[-3px] bg-current align-middle" />
    {children}
  </p>
);
